// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var isAppInForeground = function () {
    return true;
};
export { isAppInForeground };
//# sourceMappingURL=AppUtils.js.map